export default __webpack_public_path__ + "static/media/icon-file.51e6e0cc.svg";